export default __webpack_public_path__ + "static/media/Standard37.8b2dafaf.png";